
document.addEventSelectorListener("click", "[data-variable-fields='add']", function(event, target) {
	event.preventDefault();
	var container = target.closest(".variable-fields");
	var template = container.querySelector("template");
	var clon = template.cloneNode(true);

	var newIndex = 0;
	var elements = container.querySelectorAll("[data-variable-field-index]");
	for (var i = 0; i < elements.length; ++i) {
		var index = parseInt(elements[i].getAttribute("data-variable-field-index"));
		if (newIndex < index) {
			newIndex = index;
		}
	}
	newIndex += 1;

	clon.innerHTML = clon.innerHTML.replace(/___variable_field_index___/g, newIndex);
	container.insertBefore(clon.content, template);
});

document.addEventSelectorListener("click", "[data-variable-fields='remove']", function(event, target) {
	event.preventDefault();
	var parent = target.closest(".variable-field");
	parent.remove();
});
